import React from "react";
import { Tooltip, styled, tooltipClasses } from "@mui/material";

const LightTooltip = styled(
  React.forwardRef(({ className, ...props }, ref) => (
    <Tooltip {...props} ref={ref} classes={{ popper: className }} />
  ))
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.6)",
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
}));

export default LightTooltip;